import React, { useState } from "react";
import Modal from "./Modal";

const CampaignResult = ({ campaign, onDelete, onEdit  }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [pointsFor30Sec, setPointsFor30Sec] = useState(campaign.pointsFor30Sec);
    const [pointsForHalf, setPointsForHalf] = useState(campaign.pointsForHalf);
    const [pointsForFull, setPointsForFull] = useState(campaign.pointsForFull);
    const [message, setMessage] = useState("");

    const handleSave = () => {
        onEdit(campaign._id, { pointsFor30Sec, pointsForHalf, pointsForFull })
            .then((responseMessage) => {
                setMessage(responseMessage);
            })
            .catch((error) => {
                setMessage(error.message || "Failed to update campaign");
            });
    };

    return (
        <div className="campaign-result">
            <div className="campaign-box">
                <div className="campaign-header">
                    <div className="campaign-date">{campaign.creationDate}</div>
                    <div class="campaing-action">
                        <button className="delete-button" onClick={onDelete}>
                        </button>
                        <button className="edit-button" onClick={() => setIsModalOpen(true)}>
                        </button>
                    </div>
                </div>
                <div className="campaign-info">
                    <img className="campaign-image" src={campaign.image} alt={campaign.title} />
                    <div className="campaign-details">
                        <h5 className="campaign-title">{campaign.title}</h5>
                        <p className="campaign-author">{campaign.author}</p>
                        <p className="point-stats">
                            <div className="ico-point-small"></div>Budget: {campaign.budgetPoints}
                        </p>
                        <p className="point-stats">
                            <div className="ico-point-small"></div>Spend: {campaign.spentPoints}
                        </p>
                    </div>
                </div>
            </div>
            <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} title="Edit Campaign">
                <div className="form-group points-input-group">
                    <label>Points for 30 seconds:</label>
                    <div className="input-wrapper">
                        <div class="adjust-wrapper">
                            <button
                                className="input-button increase"
                                onClick={() => setPointsFor30Sec((prev) => prev + 1)}
                                type="button"
                            >

                            </button>
                            <button
                                className="input-button decrease"
                                onClick={() => setPointsFor30Sec((prev) => Math.max(prev - 1, 1))}
                                type="button"
                            >

                            </button>
                        </div>
                        <input
                            type="number"
                            value={pointsFor30Sec}
                            onChange={(e) => setPointsFor30Sec(Number(e.target.value))}
                            className="points-input"
                            min="1"
                            required
                        />

                    </div>
                </div>
                <div className="form-group points-input-group">
                    <label>Points for half track:</label>
                    <div className="input-wrapper">
                        <div class="adjust-wrapper">
                            <button
                                className="input-button increase"
                                onClick={() => setPointsForHalf((prev) => prev + 1)}
                                type="button"
                            >

                            </button>
                            <button
                                className="input-button decrease"
                                onClick={() => setPointsForHalf((prev) => Math.max(prev - 1, 1))}
                                type="button"
                            >

                            </button>
                        </div>
                        <input
                            type="number"
                            value={pointsForHalf}
                            onChange={(e) => setPointsForHalf(Number(e.target.value))}
                            className="points-input"
                            min="1"
                            required
                        />
                    </div>
                </div>
                <div className="form-group points-input-group">
                    <label>Points for full track:</label>
                    <div className="input-wrapper">
                        <div class="adjust-wrapper">
                            <button
                                className="input-button increase"
                                onClick={() => setPointsForFull((prev) => prev + 1)}
                                type="button"
                            >

                            </button>
                            <button
                                className="input-button decrease"
                                onClick={() => setPointsForFull((prev) => Math.max(prev - 1, 1))}
                                type="button"
                            >

                            </button>
                        </div>
                        <input
                            type="number"
                            value={pointsForFull}
                            onChange={(e) => setPointsForFull(Number(e.target.value))}
                            className="points-input"
                            min="1"
                            required
                        />

                    </div>
                </div>
                <button onClick={handleSave} className="submit-btn">
                    Save
                </button>
                {message && <p className="message">{message}</p>}
            </Modal>
        </div>
    );
};

export default CampaignResult;